import React from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CustomDateTimePicker = ({
  value,
  onChange,
  label,
  error = false,
  helperText = "",
  sx = {},
  disabled = false,
  minDateTime = null,
  maxDateTime = null,
  format = "DD/MM/YYYY HH:mm",
  ...props
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        value={value}
        onChange={onChange}
        label={label}
        disabled={disabled}
        minDateTime={minDateTime}
        maxDateTime={maxDateTime}
        format={format}
        slotProps={{
          textField: {
            error: error,
            helperText: helperText,
            fullWidth: true,
            sx: {
              "& .MuiOutlinedInput-root": {
                borderRadius: "6px",
                "& .MuiOutlinedInput-input": {
                  padding: "12px 16px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid #d1d5db`,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid #d1d5db !important`,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid #d1d5db !important`,
                },
              },
              "& .Mui-error": {
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid #d32f2f !important`,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid #d32f2f !important`,
                },
              },
              "& .MuiFormHelperText-root": {
                marginLeft: 0,
                marginTop: 0,
              },
              "& .Mui-disabled": {
                cursor: "not-allowed",
              },
              ...sx,
            },
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default CustomDateTimePicker;
